"use client";

import { Button } from "@oreme/ui";
import { useAtomValue, useSetAtom } from "jotai";
import { sampleSize } from "lodash";
import { RotateCcw } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type ReactElement, useState } from "react";
import {
  selectedTagIdsAtom,
  selectedObservatoryAtom,
  favouriteTagsAtom,
} from "@/store/devices";
import dynamic from "next/dynamic";
import type { Tag } from "@/types";

const DevicesTagList = dynamic<{ tags: Tag[] }>(
  () => import("./tag-list").then((mod) => mod.DevicesTagList),
  { ssr: false },
);

function DevicesTagSuggest(): ReactElement {
  const t = useTranslations("devices.TagSuggest");
  const favouriteTags = useAtomValue(favouriteTagsAtom);
  const setSelectedTagIds = useSetAtom(selectedTagIdsAtom);
  const setSelectedObservatory = useSetAtom(selectedObservatoryAtom);
  const sampleNumber = 8;

  const [sampledTags, setSampledTags] = useState(() => {
    return sampleSize(favouriteTags, sampleNumber);
  });

  const handleReset = (): void => {
    const newSampledTags = sampleSize(favouriteTags, sampleNumber);

    setSelectedObservatory(null);
    setSelectedTagIds([]);
    setSampledTags(newSampledTags);
  };

  return (
    <div className="flex flex-col gap-1">
      <header className="flex flex-row justify-between items-center">
        <h3 className="text-xs">{t("title")}</h3>
        <Button
          className="border-0"
          onClick={handleReset}
          size="icon-xs"
          variant="ghost"
          title={t("reset")}
        >
          <RotateCcw size={16} />
        </Button>
      </header>
      <DevicesTagList tags={sampledTags} />
    </div>
  );
}

export { DevicesTagSuggest };
